import { deleteHttp, post } from "../../../../common/api/apiShared";
import { ValidationError } from "../../../../common/validationError";
import { useSelectableLegalEntityQuery } from "../../../../legalEntity/useSelectableLegalEntityQuery";
import { SystemModel } from "../../../../system/systemEdit/SystemEdit.types";
import { useTransferBasisQuery } from "../../../../processingActivity/hooks/useTransferBasisQuery";
import { useExpandedId } from "../../../../common/hooks/useExpandedId";
import { getSystemEditQueryKey } from "../../../../system/systemEdit/SystemEdit.hooks";
import { useDotLegalQueryClient, useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";

export interface ISystemSupplierStep {
    validationErrors: Array<ValidationError>;
    readOnly: boolean;
    system: SystemModel;
}

export function useSystemSupplerStepHooks(props: ISystemSupplierStep) {
    const queryClient = useDotLegalQueryClient();
    const { getExpandedId, setExpandedId } = useExpandedId();

    const queryKey = getSystemEditQueryKey(props.system.id);

    let legalEntitiesQuery = useSelectableLegalEntityQuery();

    let transferBasisQuery = useTransferBasisQuery(true);

    let legalEntityLoading = legalEntitiesQuery.isLoading;
    let transferBasisLoading = transferBasisQuery.isLoading;

    let legalEntityData = legalEntitiesQuery.data;
    let transferBasisData = transferBasisQuery.data;

    function onExpandClick(id: string) {
        if (getExpandedId() === id) {
            setExpandedId("");
        } else {
            setExpandedId(id);
        }
    }

    const addSupplierMutation = useDotLegalMutation(addSupplierAPI, {
        onSuccess: (data) => {
            const system = data.value();
            queryClient.setQueryData(queryKey, system);

            const lastItem = system.suppliers[system.suppliers.length - 1];
            setExpandedId(lastItem.id);
        },
    });

    const addSupplier = async () => {
        await addSupplierMutation.mutateAsync();
    };

    const removeSupplierMutation = useDotLegalMutation(removeSupplierApi, {
        onSuccess: (data) => {
            const system = data.value();
            queryClient.setQueryData(queryKey, system);
        },
    });

    const removeSupplier = async (supplierId: string) => {
        await removeSupplierMutation.mutateAsync({ systemId: props.system.id, supplierId: supplierId });
    };

    return {
        legalEntityLoading,
        legalEntityData,
        transferBasisLoading,
        transferBasisData,
        getExpandedId,
        setExpandedId,
        onExpandClick,
        addSupplier,
        removeSupplier,
        isAddingSupplier: addSupplierMutation.isLoading,
    };

    async function addSupplierAPI() {
        return await post<SystemModel>(`/system/${props.system.id}/supplier`, {});
    }

    async function removeSupplierApi(data: { systemId: string; supplierId: string }) {
        const temp = { ...props.system };
        temp.suppliers = temp.suppliers.filter((x) => x.id !== data.supplierId)!;

        queryClient.setQueryData(queryKey, temp);

        return await deleteHttp(`/system/${data.systemId}/supplier/${data.supplierId}`);
    }
}
